import React from "react";

import CheckoutPodcasts from "./CheckoutPodcasts";
import ArticleCardContainer from "../../ArticleCardContainer";
import PartialContentTemplate from "../../ContentComponents/PartialContentTemplate";

const LearnPodcasts = ({ posts, t }) => {
  return (
    <div id="podcasts">
      <CheckoutPodcasts
        title={t("learn.checkoutPodcast.title")}
        btnViewAllPodcast={t("learn.checkoutPodcast.viewAllPodcast")}
      />

      <PartialContentTemplate
        headerHTML={t("learn.podcast.title")}
        btnLabel={t("common.seeMore")}
        btnHref={`/learn/filtration/?topic=podcasts`}
      >
        <ArticleCardContainer
          posts={posts}
          topics={["podcasts"]}
          linkText={t("common.learnMore")}
        />
      </PartialContentTemplate>
    </div>
  );
};

export default LearnPodcasts;
